/**
 * Fare-tabanlı sürükleme çekirdeği — ORTAK.
 *
 * Neden native HTML5 DnD değil: overlay mount'u Chrome'da `dragstart`'ı iptal
 * ediyordu ve otomatik testten sürüklenemiyordu (form builder'da bedeli ödendi).
 *
 * Bu yardımcı, FormBuilderDrawer ve FormsDashboard'da iki kez kopyalanmış olan
 * aynı iskeleti tek yere toplar. Kopyalar arasındaki tek anlamlı fark
 * `buttons === 0` kontrolüydü: fare pencere dışında bırakılınca `mouseup`
 * gelmez ve sürükleme takılı kalır. Burada HER ZAMAN uygulanır.
 */

export interface PointerDragOptions {
  /** Bu seçicilerden birinin içinden başlayan basış sürükleme başlatmaz (buton, tutamaç vb.). */
  ignoreSelectors?: string[];
  /** Tıklama ile sürüklemeyi ayıran Manhattan eşiği (px). */
  threshold?: number;
  /** Sürükleme sürerken eklenecek sınıf. */
  dragClass?: string;
  /** Sınıfın ekleneceği element (varsayılan `document.body`). */
  dragClassTarget?: HTMLElement | null;
  /** Eşik aşılıp sürükleme GERÇEKTEN başladığında. */
  onStart?: () => void;
  /** Sürükleme sırasında her harekette. */
  onMove?: (x: number, y: number) => void;
  /** Bitişte. `moved=false` ise bu bir tıklamaydı — bırakma işlemi yapmayın. */
  onEnd?: (x: number, y: number, moved: boolean) => void;
}

export function startPointerDrag(e: { button: number; target: EventTarget | null; clientX: number; clientY: number }, opts: PointerDragOptions): void {
  if (e.button !== 0) return; // yalnız sol tuş
  const tgt = e.target as HTMLElement | null;
  for (const sel of opts.ignoreSelectors ?? []) {
    if (tgt?.closest(sel)) return;
  }

  const threshold = opts.threshold ?? 5;
  const startX = e.clientX, startY = e.clientY;
  const classTarget = opts.dragClassTarget ?? document.body;
  let started = false;
  let lastX = startX, lastY = startY;

  const finish = (x: number, y: number) => {
    document.removeEventListener("mousemove", move);
    document.removeEventListener("mouseup", up);
    if (opts.dragClass) classTarget?.classList.remove(opts.dragClass);
    opts.onEnd?.(x, y, started);
  };

  const move = (ev: MouseEvent) => {
    // Fare pencere dışında bırakıldıysa mouseup hiç gelmez → sürükleme takılı kalırdı.
    if (ev.buttons === 0) { finish(lastX, lastY); return; }
    lastX = ev.clientX; lastY = ev.clientY;
    if (!started) {
      if (Math.abs(ev.clientX - startX) + Math.abs(ev.clientY - startY) < threshold) return;
      started = true;
      if (opts.dragClass) classTarget?.classList.add(opts.dragClass);
      window.getSelection()?.removeAllRanges(); // sürüklerken metin seçilmesin
      opts.onStart?.();
    }
    ev.preventDefault();
    opts.onMove?.(ev.clientX, ev.clientY);
  };

  const up = (ev: MouseEvent) => finish(ev.clientX, ev.clientY);

  document.addEventListener("mousemove", move);
  document.addEventListener("mouseup", up);
}
